import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { CheckoutIntent } from '@appTypes/payment';

import { initialSliceState } from '../constants';

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState: initialSliceState,

  reducers: {
    setCheckoutIntent: (
      state,
      action: PayloadAction<{
        checkoutIntent: CheckoutIntent | null;
      }>,
    ) => {
      const { checkoutIntent } = action.payload;
      state.checkoutIntent = checkoutIntent;
    },
  },
});

const { reducer: sliceReducer, actions } = paymentsSlice;

export const { setCheckoutIntent } = actions;
export { sliceReducer };
